module.exports = __webpack_public_path__ + "img/USDTE.48a0e22c.png";